import AddCommentsDialog from "../../Comments/AddCommentsDialog/AddCommentsDialog";
import { ADD_COMMENTS_PROPS, ADD_COMMENTS_STATE } from "../../Comments/AddCommentsDialog/Types";

type PROPS = {
  comment: string
  setComment: Function
} & ADD_COMMENTS_PROPS;

class CommentDialog extends AddCommentsDialog<PROPS, ADD_COMMENTS_STATE> {
  buttonUpdateAction = 'updateGradeAndScoringCommentsDialog';
  state: ADD_COMMENTS_STATE = {
    comment: ''
  };

  /**
   * @inheritDoc
   * @param props
   */
  constructor(props: PROPS) {
    super(props);
    this.state = {
      comment: props.comment
    };
  }

  /**
   * Calls method for saving comment.
   */
  addComment = () => this.props.setComment(this.state.comment);

  /**
   * @inheritDoc
   */
  addValueField = () => {
    return {
      value: this.state.comment
    }
  };

  /**
   * @inheritDoc
   * @param comment
   */
  updateToolbar = (comment: string) => {
    const { comment: oldComment } = this.props;
    let disableSaveButton = false;
    if (!comment || comment === oldComment) {
      disableSaveButton = true;
    }
    this.dispatch(this.buttonUpdateAction, '', { disableSaveButton });
  };

}

export default CommentDialog;